/* Reuse Dawn's original submit button: one variant/quantity/cart source of truth. */
if (!customElements.get('gs-mobile-cart')) {
  customElements.define('gs-mobile-cart', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById(this.dataset.productSection);
      if (!this.root) return;
      this.button = this.querySelector('button');
      this.mobile = matchMedia('(max-width: 749px)');
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
      };
      this.submit = () => {
        const original = this.root.querySelector('.product-form__submit');
        if (!original || original.disabled || original.getAttribute('aria-disabled') === 'true') return;
        original.click();
        this.sync();
        const error = this.root.querySelector('.product-form__error-message-wrapper');
        if (error && !error.hidden) error.scrollIntoView({ block: 'center' });
      };
      this.button.addEventListener('click', this.submit);
      this.observer = new MutationObserver(() => {
        this.schedule();
        const error = this.root.querySelector('.product-form__error-message-wrapper');
        if (error && !error.hidden && error.textContent.trim()) error.scrollIntoView({ block: 'center' });
      });
      this.observer.observe(this.root, { subtree: true, childList: true, characterData: true,
        attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden', 'value'] });
      this.bodyObserver = new MutationObserver(this.schedule);
      this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this.root);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule);
      window.visualViewport?.addEventListener('resize', this.schedule);
      window.visualViewport?.addEventListener('scroll', this.schedule);
      document.addEventListener('toggle', this.schedule, true);
      this.mobile.addEventListener('change', this.schedule);
      this.sync();
    }
    sync() {
      const original = this.root.querySelector('.product-form__submit');
      if (!original) { this.hidden = true; return; }
      const disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
      this.button.disabled = disabled;
      this.button.textContent = original.querySelector('span:not(.hidden)')?.textContent.trim() || original.textContent.trim();
      this.button.setAttribute('aria-busy', String(original.classList.contains('loading')));
      if (original.hasAttribute('aria-haspopup')) this.button.setAttribute('aria-haspopup', original.getAttribute('aria-haspopup'));
      const selections = [...this.root.querySelectorAll('variant-selects input:checked, variant-selects select')].map(input => input.value);
      this.querySelector('[data-gs-options]').textContent = selections.join(' / ');
      const price = this.root.querySelector('.price__sale .price-item--sale') || this.root.querySelector('.price__regular .price-item--regular');
      const sale = this.root.querySelector('.price--on-sale');
      this.querySelector('[data-gs-price]').textContent = (sale ? price : this.root.querySelector('.price__regular .price-item--regular'))?.textContent.trim() || '';
      const openDialog = [...document.querySelectorAll('[role="dialog"][aria-modal="true"]:not([hidden])')].some(dialog => {
        // Dawn's closed search disclosure can still have a tiny visible box.
        // It is not an open modal and must not suppress the purchase bar.
        if (dialog.closest('details:not([open]), [hidden], [aria-hidden="true"]')) return false;
        const box = dialog.getBoundingClientRect();
        const style = getComputedStyle(dialog);
        return style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) > 0 && box.width > 10 && box.height > 10 && box.left < innerWidth && box.right > 0 && box.top < innerHeight && box.bottom > 0;
      });
      const blocked = openDialog ||
        !!document.querySelector('cart-drawer.active, cart-notification.active, product-modal[open]');
      // Only appear after the original CTA has scrolled above the viewport.
      // The gallery and variant controls are never covered while choosing.
      const viewport = window.visualViewport;
      const viewportBottom = viewport ? viewport.offsetTop + viewport.height : innerHeight;
      const previewFrame = document.getElementById('PBarNextFrame');
      const previewBox = previewFrame?.getBoundingClientRect();
      const previewOverlap = previewBox && getComputedStyle(previewFrame).display !== 'none' && previewBox.top < viewportBottom && previewBox.bottom > viewportBottom - 2 ? Math.max(0, viewportBottom - previewBox.top) : 0;
      this.style.bottom = Math.max(innerHeight - viewportBottom, previewOverlap) + 'px';
      const visible = this.mobile.matches && original.getBoundingClientRect().bottom < 0 && !blocked;
      this.hidden = !visible;
      this.classList.toggle('gs-cart-visible', visible);
      const ready = this.mobile.matches;
      if (document.body.classList.contains('gs-mobile-cart-ready') !== ready) document.body.classList.toggle('gs-mobile-cart-ready', ready);
      if (visible) document.body.style.setProperty('--gs-mobile-cart-height', `${this.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.bodyObserver?.disconnect(); this.resizeObserver?.disconnect();
      window.removeEventListener('scroll', this.schedule); window.removeEventListener('resize', this.schedule);
      this.mobile?.removeEventListener('change', this.schedule);
      window.visualViewport?.removeEventListener('resize', this.schedule);
      window.visualViewport?.removeEventListener('scroll', this.schedule);
      document.removeEventListener('toggle', this.schedule, true);
      if (this.frame) cancelAnimationFrame(this.frame);
      document.body.classList.remove('gs-mobile-cart-ready');
      document.body.style.removeProperty('--gs-mobile-cart-height');
    }
  });
}
